import { PolyNodeParamsConfig } from "../../../utils/poly/PolyNodeParamsConfig";
import { AbstractTypedSubnetGlNode, TypedSubnetGlParamsConfigMixin } from "../../Subnet";
import { NodeParamsConfig } from "../../../utils/params/ParamsConfig";
export function createPolyGlNode(nodeType, definition, polyNodeControllerClass) {
  class SubnetGlParamsConfig extends TypedSubnetGlParamsConfigMixin(NodeParamsConfig) {
  }
  const ParamsConfig = PolyNodeParamsConfig.ParamsConfig(definition, SubnetGlParamsConfig);
  class BasePolyGlNode extends AbstractTypedSubnetGlNode {
    constructor() {
      super(...arguments);
      this.paramsConfig = ParamsConfig;
      this.polyNodeController = new polyNodeControllerClass(this, definition);
    }
    static type() {
      return nodeType;
    }
    _expectedInputTypes() {
      var _a, _b;
      return ((_b = (_a = definition.inputs) == null ? void 0 : _a.typed) == null ? void 0 : _b.types.map((t) => t.type)) || [];
    }
    _expectedInputName(index) {
      var _a, _b;
      const names = ((_b = (_a = definition.inputs) == null ? void 0 : _a.typed) == null ? void 0 : _b.types.map((t) => t.name)) || [];
      return names[index];
    }
    _expectedOutputTypes() {
      return this._expectedInputTypes();
    }
    _expectedOutputName(index) {
      return this._expectedInputName(index);
    }
  }
  return BasePolyGlNode;
}
